<div class="selection-container">
  <h6 class="odx-title-6" i18n="@@localeSelection.header1">Land auswählen</h6>
  <p class="odx-text--small" i18n="@@localeSelection.subtitle1">
    Es werden die für dieses Land verfügbaren Artikel und die festgelegten Preise angezeigt.
  </p>

  <form odxForm [formGroup]="countrySelectionForm">
    <app-country-selection-form-field
      [formGroup]="countrySelectionForm"
      [countries]="(supportedCountries$ | async) ?? []"
      (selectCountry)="selectCountry($event)"
    ></app-country-selection-form-field>
  </form>
</div>
